import Cresline from '../../../Assets/Cresline.svg';
import EagleDispatch from '../../../Assets/EagleDispatch.svg';
import GLogistics from '../../../Assets/GLogistics.svg';
import Ivanni from '../../../Assets/Ivanni.svg';
import Adeeva from '../../../Assets/Adeeva.svg';

export const AboutUsSponsors = [
	{
		img: Cresline,
		id: 1,
	},
	{
		img: EagleDispatch,
		id: 2,
	},
	{
		img: GLogistics,
		id: 3,
	},
	{
		img: Ivanni,
		id: 4,
	},
	{
		img: Adeeva,
		id: 5,
	},
];
